// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","tablet":"(max-width: 1024px)","startSearch":"S4Zt3ZVYw7Bg","startSearch_advanced":"_2Kwq37Lsf-IH","startSearch_multiCity":"cB913VZYGWR2"};